<template>
    <div id="header">
        <img src="../assets/media/apps/sapx-logo.svg" class="img-logo"/>
    </div>
</template>
<script>
export default {
  name: 'HeaderMobile'
}
</script>
<style scoped>
.img-logo{
    width:15%;
}
#header{
    background:white;
    padding:10px;
    border-bottom:1px solid rgba(0,0,0,0.1);
    position:fixed;
    z-index:10;
    width:100%;
}
#header img{
    width:90px;
}
</style>
